import validator from "validator";
import message from "../../../messages/category-user-site-publishers";

const validateName = (name) => {
  if (validator.isEmpty(name)) {
    return message.NAME_DOSE_NOT_EXIST;
  }

  if (!name.trim().length) {
    return message.NAME_DOSE_NOT_EXIST;
  }

  return true;
};

const validateTypeAdvertiseID = (typeAdvertiseID) => {
  if (validator.isEmpty(typeAdvertiseID)) {
    return message.TYPE_ADVERTISE_DOSE_NOT_EXIST;
  }

  if (!validator.isNumeric(typeAdvertiseID)) {
    return message.TYPE_ADVERTISE_INVALID;
  }

  return true;
};
const validateAmount = (amount) => {
  if (validator.isEmpty(amount + "")) {
    return message.AMOUNT_DOSE_NOT_EXIST;
  }

  if (!validator.isNumeric(amount + "")) {
    return message.AMOUNT_SITES_INVALID;
  }

  return true;
};

const validateListSitePublisher = (sitesList) => {
  if (!hasSitePublisher(sitesList)) {
    return message.SITE_LIST_INVALID;
  }

  return true;
};

const hasSitePublisher = (sites) => {
  if (Object.keys(sites).length === 0) {
    return false;
  }

  let resultCheck = true;
  for (let key in sites) {
    if (Object.keys(sites[key]).length < 2) {
      return false;
    }
    
    if (!validator.isNumeric(key)) {
      resultCheck = false;
      break;
    }

    if (!hasUrlSitePublisher(sites[key])) {
      resultCheck = false;
      break;
    }

    if (!hasPagesInSitePublisher(sites[key])) {
      resultCheck = false;
      break;
    }
  }

  return resultCheck;
};

const hasPagesInSitePublisher = (pagesInSitePublisher) => {
  if (Object.keys(pagesInSitePublisher).length === 0) {
    return false;
  }

  let resultCheck = true;
  let newPagesInSitePublisher = { ...pagesInSitePublisher };
  delete newPagesInSitePublisher.url;
  for (let key in newPagesInSitePublisher) {
    if (!validator.isNumeric(key)) {
      resultCheck = false;
      break;
    }

    if (!hasTitlePage(newPagesInSitePublisher[key])) {
      resultCheck = false;
      break;
    }

    if (!hasPricePage(newPagesInSitePublisher[key])) {
      resultCheck = false;
      break;
    }

    if (!hasPositionArray(newPagesInSitePublisher[key])) {
      resultCheck = false;
      break;
    }
  }

  return resultCheck;
};

const hasTitlePage = (page) => {
  if (!page.hasOwnProperty("title")) {
    return false;
  }

  if (page.title == null) {
    return false;
  }
  const pageTitle = page.title;
  if (!pageTitle.trim().length) {
    return false;
  }

  return true;
};

const hasPricePage = (page) => {
  if (!page.hasOwnProperty("price")) {
    return false;
  }

  if (page.price == null) {
    return false;
  }
  const pagePrice = page.price;
  if (!validator.isNumeric(pagePrice + "")) {
    return false;
  }

  return true;
};

const hasPositionArray = (page) => {
  if (!page.hasOwnProperty("positions")) {
    return false;
  }

  if (page.positions == null) {
    return false;
  }
  const positions = page.positions;
  if (!Array.isArray(positions)) {
    return false;
  }

  return true;
};

const hasUrlSitePublisher = (sitePublisher) => {
  if (!sitePublisher.hasOwnProperty("url")) {
    return false;
  }

  if (sitePublisher.url == null) {
    return false;
  }
  const url = sitePublisher.url;
  if (!validator.isURL(url)) {
    return false;
  }

  return true;
};

const validateFormPermission = (info) => {
  const resValidateName = validateName(info.name);
  if (resValidateName != true) {
    return resValidateName;
  }

  const resValidateTypeAdvertiseID = validateTypeAdvertiseID(info.type_id);
  if (resValidateTypeAdvertiseID != true) {
    return resValidateTypeAdvertiseID;
  }

  const resValidateAmount = validateAmount(info.amount);
  if (resValidateAmount != true) {
    return resValidateAmount;
  }

  const resValidateListSitePublisher = validateListSitePublisher(info.sites);
  if (resValidateListSitePublisher != true) {
    return resValidateListSitePublisher;
  }

  return true;
};

export default validateFormPermission;
